import { render, staticRenderFns } from "./cooperation_institution.html?vue&type=template&id=6d8ea82d&scoped=true&name=cooperation_institution&external"
import script from "./cooperation_institution.js?vue&type=script&lang=js&external"
export * from "./cooperation_institution.js?vue&type=script&lang=js&external"
import style0 from "./cooperation_institution.less?vue&type=style&index=0&id=6d8ea82d&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ea82d",
  null
  
)

export default component.exports